import React, {useEffect, useState} from 'react';
import BankTransferAPI from "../../api/BankTransferAPI";
import {CircularProgress} from "@mui/material";
import {capitalizeFirstLetters} from "../../features/ValueFormater";

const DropdownInput = ({setPayload}) => {
    const [dropdownValue, setDropdownValue] = useState("Select");
    const [textInput, setTextInput] = useState('');

    const {GetBeneficiaryNames, names, namesLoading} = BankTransferAPI();


    useEffect(() => {
        GetBeneficiaryNames();
    }, []);

    useEffect(() => {
        if (dropdownValue) {
            setPayload((prevState) => ({
                ...prevState,
                BeneficiaryName: dropdownValue
            }));
        }
    }, [dropdownValue]);

    const handleButtonClick = (value, event) => {
        event.preventDefault();
        setDropdownValue(value);
    };

    const handleTextInputChange = (event) => {
        setTextInput(event.target.value);
    };

    const handleTextInputBlur = () => {
        if (textInput.length > 0) {
            setDropdownValue(textInput);
        }
    };
    return (
        <div className="dropdown-input">
            <div className="dropdown">
                <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1"
                        data-bs-toggle="dropdown" aria-expanded="false">
                    <div className={dropdownValue === "Select"&& "placeholder-color"}>
                        {dropdownValue}
                    </div>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {
                        namesLoading ? (
                            <div className="loading">
                                <CircularProgress color="inherit"/>
                            </div>
                        ) : (
                            <>
                                {
                                    names && names.map((name) => (
                                        <li>
                                            <button onClick={(event) => handleButtonClick(name.BeneficiaryName, event)}>{capitalizeFirstLetters(name.BeneficiaryName)}</button>
                                        </li>
                                    ))
                                }
                            </>
                        )

                    }
                    <li><input type="text"
                               value={textInput}
                               placeholder="+ Add New"
                               onChange={handleTextInputChange}
                               onBlur={handleTextInputBlur}/></li>
                </ul>
            </div>
        </div>
    );
};

export default DropdownInput;
